import PropTypes from "prop-types";
import InnerImageZoom from "react-inner-image-zoom";
import { createShopifyUrl } from "@components/al_components/ALShopifyImage";

import "./desktopImage/styles.scss";

const PDP_DESKTOP_IMAGE_MAX_WIDTH = 1080; // Based on asset original size
const RESPONSIVE_WIDTHS = [PDP_DESKTOP_IMAGE_MAX_WIDTH * 0.5, PDP_DESKTOP_IMAGE_MAX_WIDTH * 0.75];

function generateFixedSrcSet({ url, widths }) {
  return `${widths
    .map((width) => `${createShopifyUrl({ url, width })} ${width}w`)
    .join(", ")}, ${url} ${PDP_DESKTOP_IMAGE_MAX_WIDTH}w`;
}

function DesktopImage({ children, image }) {
  if (!image) {
    return null;
  }
  const { altText, url } = image;

  const sources = [
    {
      srcSet: generateFixedSrcSet({
        url,
        widths: RESPONSIVE_WIDTHS,
      }), // Browser automatically picks the best image source based on the viewport size and device pixel ratio
      sizes: "38vw", // Estimation of the size of the image container compared to viewport
    },
  ];

  return (
    <div className="pdp_image w-full relative aspect-[0.8] overflow-hidden">
      {children}
      <InnerImageZoom
        className="w-full h-full"
        src={url}
        hideHint
        hideCloseButton
        zoomScale={1}
        imgAttributes={{ alt: altText, loading: "lazy" }}
        sources={sources}
      />
    </div>
  );
}

DesktopImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    altText: PropTypes.string,
  }),
};

export default DesktopImage;
